import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { BillType } from '../../bills/enums/billType'
import { PayableSubject } from '../types'
import { PayableSubjectType } from '../types/payableSubjectType'
import { PostingType } from '../types/postingType'
import { isExternalInvoice } from './isExternalInvoice'
import { isSubjectInvoice } from './isSubjectInvoice'

type PayableSubjectTypeExcludingPosting = Exclude<PayableSubjectType, PostingType.Posting>

export const getTypeFromPayableSubject = (subject?: PayableSubject): PayableSubjectTypeExcludingPosting => {
  if (subject && isExternalInvoice(subject)) {
    return InvoiceType.ExternalInvoice
  }

  if (subject && isSubjectInvoice(subject)) {
    return InvoiceType.Invoice
  }

  return BillType.Bill
}
